import { List } from 'immutable';
import MenuItemCustomCategory, { MenuItemCustomCategories } from 'records/MenuItemCustomCategory';
import BaseList from 'records/BaseList';

import {
  MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_START,
  MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR,
  MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_SUCCESS,
  MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS,
  MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_SUCCESS,
  MENU_ITEM_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE,
  MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS,
  MENU_ITEM_CUSTOM_CATEGORIES_RESET_STATE,
} from 'actions/menuItemCustomCategories';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const recipeCustomCategoriesData = MenuItemCustomCategories(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: recipeCustomCategoriesData,
    });
  },
  [MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const originalData = state.data;
    const recipeCustomCategoryData = new MenuItemCustomCategory(action.data);
    const findIndex = originalData.findIndex((item) => { return item.get('id') === recipeCustomCategoryData.get('id') });
    let newData = null;
    if(findIndex > -1) {
      newData = originalData.setIn([findIndex], recipeCustomCategoryData);
    } else {
      newData = originalData.push(recipeCustomCategoryData);
    }
    newData = MenuItemCustomCategory.sortCategoriesByOrdinal(newData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newData,
    });
  },
  [MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [MENU_ITEM_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE]: (state, action) => {
    let newCategoriesData = MenuItemCustomCategory.updateCategoryOrdinalsFromIndex(action.data);
    newCategoriesData = MenuItemCustomCategory.sortCategoriesByOrdinal(newCategoriesData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newCategoriesData,
    });
  },
  [MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [MENU_ITEM_CUSTOM_CATEGORIES_RESET_STATE]: () => {
    return initialState;
  },
}

export default function menuItemCustomCategories(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
